import { getConfig } from 'config/config';

/**
 * Matches Header.jsx top-nav and withPrivateRoute feature gating for items that use
 * featureExclude + optional allowStaffWithProgramAccess (STAFF with program ADMIN/MANAGER).
 */
export function isEdoFeatureExcludeVisible(item, userData) {
  const role = userData?.role;
  const appConfig = getConfig('APP_CONFIG');
  const appId = appConfig?.appId;
  if (!role || !appId) return false;

  const excluded = item.featureExclude?.[appId]?.[role] === true;
  if (excluded && item.allowStaffWithProgramAccess && role === 'STAFF') {
    return (userData?.edoUserProgramAccesses || []).some(
      (a) => a.role === 'ADMIN' || a.role === 'MANAGER'
    );
  }
  return !excluded;
}
